var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ItemBadge',{attrs:{"itemState":_vm.item.state}}),_vm._l((_vm.item.variants),function(v){return _c('div',{key:v.id},[_c('Variant',{attrs:{"variant":v,"itemState":_vm.item.state}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }